import React, { FC } from 'react';
import { FilterIcon, SimplePopover, Tag } from '@dev/ee-components';
import { useSelector } from 'react-redux';
import { Skeleton } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';

import { getLogsStore } from '@api/store/logs/actions';

import { FilterContainer, FilterLabel, EventFilterWrapper } from '../styledComponents';
import { CustomPopoverBodyInterface, EventFilterInterface } from './Interfaces';
import { EventsFiltersTypeEnum } from '../../Interface';
import { useEventsFilters } from '../../hooks/useEventFilter';
import { some, isArray } from 'lodash-es';

const loadingOptions = new Array(8).fill({ label: '', value: undefined });

export const CustomPopoverBody: FC<CustomPopoverBodyInterface> = ({
    element,
    isLoading,
    emptyStateText,
}: CustomPopoverBodyInterface): JSX.Element => {
    const { t } = useTranslation();
    const noEventsText = emptyStateText || t('noeventssavailable');
    return (
        <FilterContainer>
            {isLoading ? (
                <Skeleton width="100%" />
            ) : (
                <>
                    <FilterLabel>{element?.isEmpty ? noEventsText : element.label}</FilterLabel>
                    {element.count && <Tag label={element.count} clickable={false} />}
                </>
            )}
        </FilterContainer>
    );
};

export const EventFilter: FC<EventFilterInterface> = ({
    selectedCheckboxes = [],
    onHeadersEventFilterClick,
    options,
    eventFiltersType,
}: EventFilterInterface): JSX.Element => {
    const isInProgressLogs = eventFiltersType === EventsFiltersTypeEnum.InProgress;
    const { countsLoading } = useSelector(getLogsStore);
    const { t } = useTranslation();
    const { fetchEventsCounts, shouldRefetchData } = useEventsFilters({ eventFiltersType });

    if (!onHeadersEventFilterClick) {
        return <></>;
    }

    const isEventsLoading = shouldRefetchData || countsLoading;

    const dropdownOptions = isEventsLoading ? loadingOptions : options;
    const hasMessageCategory = isEventsLoading || some(dropdownOptions, isArray);

    return (
        <EventFilterWrapper {...{ hasMessageCategory }}>
            <SimplePopover
                type="icon"
                options={dropdownOptions}
                checkboxValue={selectedCheckboxes}
                customDropdownBody={(element): JSX.Element => (
                    <CustomPopoverBody isLoading={isEventsLoading} element={element as { count: number; label: string; value: string }} />
                )}
                enableCheckbox
                onCheckboxClick={onHeadersEventFilterClick}
                groupNameWithCheckbox
                listItemWidth={isInProgressLogs ? 200 : 350}
                maxHeight={300}
                translations={{
                    noResults: t('noeventssavailable'),
                }}
            >
                <FilterIcon onClick={fetchEventsCounts} />
            </SimplePopover>
        </EventFilterWrapper>
    );
};
